import './dashboard.less';

import classNames from 'classnames';
import React from 'react';
import {Link, browserHistory} from 'react-router';
import DashBoardHeader from '../header_dashboard/dashboard_header';

import dashboardActions from './dashboard_actions';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import ShowError from '../components/error/show_error';
import CONSTANTS from '../common_constants';

import LoggedinFooter from '../footer/loggedin_footer';
import cookies from '../util/cookie';
import ModalPopUp from '../components/modalPopUp/modalPopUp';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import ShipmentDetail from './shipment_detail';
import EmptyShipments from './empty_shipment';

class PostRequestItemUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAll : false
    }
  }
  toggleShowAllOptions = () =>{
    this.setState({
      showAll : !this.state.showAll
    })
  }
  render() {
    return (
      <div className="post-request-option">
        {
          this.state.showAll && <div className="overlay" onClick={this.toggleShowAllOptions}>

          </div>
        }
        <div className="post-request-content">
          {
            !this.state.showAll && <div className="add-button-section">
              <span className="icon-icn_add cursor-pointer" onClick={this.toggleShowAllOptions}><span className="path1 orange"></span><span className="path2"></span></span>
            </div>
          }
          {
            this.state.showAll && <div className="all-options-section">
              <div className="options">
                  <span className="icon-icn_close2 cursor-pointer" onClick={this.toggleShowAllOptions}><span className="path1"></span><span className="path2"></span></span>
              </div>
              <div className="options">
                  <Link to="/post-a-shipment">
                    <div className = "options-title">
                      Ship a package
                    </div>
                    <div className = "options-img">
                      <span className="icon-icn_package cursor-pointer"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span></span>
                    </div>
                  </Link>
              </div>
              <div className="options">
                <Link to="/request-an-item">
                  <div className = "options-title">
                    Request an item
                  </div>
                  <div className = "options-img">
                    <span className="icon-icn_request_an_item cursor-pointer"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span></span>
                  </div>
                </Link>
            </div>
            <div className="options">
              <Link to="/add-trips">
                <div className = "options-title">
                  Add Trip
                </div>
                <div className = "options-img">
                  <span className="icon-icn_globe cursor-pointer"><span className="path1"></span><span className="path2"></span></span>
                </div>
              </Link>
          </div>
          </div>
          }
        </div>
      </div>
    )
  }
}


class DashBoard extends React.Component{

  constructor(props){
    super(props);
    const {dashboard} = props;

    this.state = {
      error: '',
    }
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.authActions.logout().always(() => {
        cookies.delete('_sd');
        document.location.href = '/';
    });
  }

  render(){

    const self = this;
    const {props, state} = this;

    let shipments = {};
    let sessionValid = true ;

    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid

    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };

    let isFirstTime;
    if(props.location)
       isFirstTime = props.location.query.isFirstTime;
    else
        isFirstTime = false;

    if(props.authState) {
      user.name = props.authState.userData.name;
      user.imageUrl = props.authState.userData.profileImageUrl;
      user.isVerified = props.authState.userData.isVerified;
    }

    return(
      <div className = "dashboard-page">
        {/*<ModalPopUp isOpen={isFirstTime}></ModalPopUp> this has been removed in new Web version*/}
        <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
        <DashBoardHeader user = {user} location={this.props.location} logout={this.logout}/>
        <div className = "d-header-wrap">
          <div className = "wrapper">
            <h2 className = "page-header d-page-header">Dashboard</h2>
          </div>
        </div>
        <div className="post-request-option-wrap">
          <PostRequestItemUI /> 
        </div>
        {this.props.children}
        <LoggedinFooter />
      </div>
    )
  }
}

DashBoard = connect((state) => {
  return {
    dashboard: state.app.dashboard,
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    dashboardActions: bindActionCreators(dashboardActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch)
  }
})(DashBoard);

module.exports = DashBoard;



// WEBPACK FOOTER //
// app/dashboard/dashboard.jsx